module.exports = __webpack_public_path__ + "static/media/emoticon-unsure.525e06d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emoticon-unsure.svg
// module id = 228
// module chunks = 0